import { FC } from 'react';
import {
  DashboardContainer, DashboardContainerBody, DashboardContainerHeader, ResolvedText, ScrollableList, StyledTitle
} from '../MoaDashboard.styles';
import { ActivationsContainerProps } from './ActivationsContainer.types';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { ExtractJobStatus } from '../../../services/dashboard/dashboard.types';
import { ITooltipParams } from 'ag-grid-community';
import ExtractMetricsDisplay from "../ExtractMetricsDisplay";
import BatchStatusDisplay from "../BatchStatusDisplay";

const ActivationsContainer: FC<ActivationsContainerProps> = (
    {
      activations,
      setDrawerColumnDefs,
      setOpenDrawer,
      setDrawerType,
      setFetchExtractionsFailure,
      setExtractionAndActivationsJobId,
      setRequestUserName
    }
) => {
  const muiTheme = createTheme();

  const activationsColumnDefs = [
    {
      minWidth: 80,
      maxWidth: 100,
      field: 'label',
      headerName: 'Store#',
      sortable: true,
      floatingFilter: false
    },
    {
      minWidth: 80,
      maxWidth: 100,
      field: 'marketNo',
      headerName: 'FZ Code',
      sortable: false,
      floatingFilter: false
    },
    {
      minWidth: 400,
      field: 'reason',
      headerName: 'Error Reason',
      sortable: false,
      floatingFilter: false,
      tooltipValueGetter: (params: ITooltipParams) => params.value
    },
    {
      minWidth: 80,
      maxWidth: 100,
      field: 'isResolved',
      headerName: '',
      sortable: false,
      floatingFilter: false,
      cellRenderer: (params: any) => {
        if (params.value) {
          return <ResolvedText>Resolved</ResolvedText>;
        }
        else {
          return '';
        }
      }
    }
  ];

  const openActivationJobStatusDrawer = (progressMetrics: ExtractJobStatus) => {
    setDrawerColumnDefs(activationsColumnDefs);
    setFetchExtractionsFailure(true);
    setOpenDrawer(true);
    setDrawerType('activate');
    setExtractionAndActivationsJobId(progressMetrics.jobId);
    setRequestUserName(progressMetrics.userName);
  };

  const inProgressActivationMetricsDisplay = () => {
    return (
        <ScrollableList data-testid="activateInProgressContainer" style={{ height: '160px' }}>
          {activations?.inProgress.length === 0
              ? <StyledTitle>No activations in progress</StyledTitle>
              : activations?.inProgress.map((inProgressMetrics) =>
                  (
                      <BatchStatusDisplay
                          key={`activation-in-progress-${inProgressMetrics.jobId}`}
                          name={`${inProgressMetrics.extractType} for ${inProgressMetrics.userName}`}
                          batchStatus={inProgressMetrics}
                          openFailedDrawer={() => openActivationJobStatusDrawer(inProgressMetrics)}
                      />
                  )
              )
          }
        </ScrollableList>
    );
  };

  return (
      <DashboardContainer data-testid={'activationsContainer'}>
        <DashboardContainerHeader data-testid="activationsContainerHeader">Activations</DashboardContainerHeader>
        <DashboardContainerBody style={{ gap: 0 }}>
          <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
            {inProgressActivationMetricsDisplay()}
            <Divider orientation="horizontal" variant={'fullWidth'} flexItem/>
            <ExtractMetricsDisplay
                extractMetrics={activations?.upNext ?? []}
                title={'Up next'}
                emptyText={'No activations waiting'}
                openDrawer={openActivationJobStatusDrawer}
                testName={'upNextActivate'}
            />
            <Divider orientation="horizontal" variant={'fullWidth'} flexItem/>
            <ExtractMetricsDisplay
                extractMetrics={activations?.done ?? []}
                title={'Done'}
                emptyText={'No activations'}
                openDrawer={openActivationJobStatusDrawer}
                testName={'doneActivate'}
            />
          </ThemeProvider>
        </DashboardContainerBody>
      </DashboardContainer>
  );
};

export default ActivationsContainer;
